import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const InlineTooltip = ({ id, tooltip }: { id: string; tooltip: any }) => {
    let inlineTooltip = <Tooltip id={id}>{tooltip}</Tooltip>;

    return (
        <OverlayTrigger overlay={inlineTooltip} placement="top" delayShow={300} delayHide={150}>
            <div className="infobutton">
                <i className="material-icons">info</i>
            </div>
        </OverlayTrigger>
    );
};

export default InlineTooltip;
